import { render } from "./MFITTExternalLinkButton.vue?vue&type=template&id=a2f5930e"
import script from "./MFITTExternalLinkButton.vue?vue&type=script&lang=js"
export * from "./MFITTExternalLinkButton.vue?vue&type=script&lang=js"

import "./MFITTExternalLinkButton.vue?vue&type=style&index=0&id=a2f5930e&lang=scss"
script.render = render

export default script